import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert-dialog',
  imports: [],
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
   providers: [NgbActiveModal] 
})
export class AlertDialogComponent {
 @Input() id: string = '';
    @Input() type: string = 'Error';
    @Output() onOkClick = new EventEmitter<string>();
    modalRef!: NgbModalRef;
    modalType: string = '';

    constructor (
        private modalService: NgbModal,
        public activeModal: NgbActiveModal
    ) {
    }

    showInfoDialog(modalType = '') {
        this.type = 'Info';
        this.modalType = modalType;
        (document.getElementById("btnAlertDialog" + this.id)as any).click();
    }

    showDialog(modalType = '') {
        this.type = 'Error';
        this.modalType = modalType;
        (document.getElementById("btnAlertDialog" + this.id)as any).click();
    }

    showErrorDialog(content:any) {
        let modalOptions: any = {
            centered: true,
            windowClass: 'ErrorModel'
        };
        if (this.modalType == 'Static') {
            modalOptions = {
                centered: true,
                windowClass: 'ErrorModel',
                size: 'sm',
                backdrop: 'static',
                keyboard: false
            };
        }
        this.modalRef = this.modalService
            .open(content, modalOptions);
        this.modalRef.result.then(
            (result:any) => { },
            (reason:any) => { }
        );
    }

    okClicked() {
        console.log('okClicked: ', this.type, this.modalType);
        this.onOkClick.emit('clicked');
        this.dismissDialog();
    }

    dismissDialog() {
        this.modalRef.close();
    }
}
